import PropTypes from 'prop-types';
import React from 'react';
import { themr } from 'react-css-themr';
import styles from './styles';

const Loading = (props) => {
  const size = {
    width: `${props.size}px`,
    height: `${props.size}px`,
  };

  const cxCySize = props.size / 2;

  return (
    <div className={props.className}>
      <div style={size}>
        <svg className={styles.circular} style={size}>
          <circle
            className={styles.path}
            cx={cxCySize}
            cy={cxCySize}
            r={props.radius}
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
    </div>
  );
};

Loading.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  radius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

Loading.defaultProps = {
  size: '100',
  radius: '20',
};

export default themr('Loading', styles)(Loading);



// WEBPACK FOOTER //
// ./client/app/shared/components/Loading/index.jsx